export default function scopeElementDirective() {
    return {
        restrict:"A",
        replace: false,
        link: function($scope, elem, attrs) {
            $scope[attrs.scopeElement] = elem[0];
        }
    }
}